import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Injectable } from '@angular/core';
import { Lead } from '../../models/lead';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadService extends ResourceService<Lead> {

 /**
   * @constructor 
   * Creates an instance of the LeadService 
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
 */

  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'leads');
  }

  /**
    * Sends a GET request to the /leads/latest endpoint
    * @remarks
    * to fetch the latest leads 
    * @returns {Observable} Returns an observable
  */
  public getLatest() {
    return this.http.get(`${this.endpoint}/latest`)
      .pipe(map((resp: any) => {
        return resp.data;
      }))
  }

  /**
    * Sends a GET request to the /leads/:parentId endpoint
    * @remarks
    * to fetch property leads
    * @param {any} param: Object representing fields or parameters to filter/query by
    * @param {boolean} raw: Optional flag that determine what is returned.
    * @returns {Observable} Returns an observable of object
  */
  public getPropertyLeads(params?: any, raw?: boolean) {
    return this.http.get(`${this.endpoint}/${this.parentId}`, { params })
      .pipe(map((resp: any) => {
        if (!raw) {
          return resp.data.leads;
        }
        return resp;
      }));
  }

  /**
    * Sends a PUT request to the /leads/:id/read endpoint
    * @remarks
    * to update leads 
    * @param {any} item: contains fields used as body of the request sent to the server
    * @returns {Observable} Returns an observable of typed Resource
  */
  public update(item: any): Observable<Lead> {
    const data: any = {
      is_new: !!item.is_new,
      is_favorite: !!item.is_favorite
    }
    return this.http.put<Lead>(`${this.endpoint}/${item.id}/read`, data)
      .pipe(map((resp: any) => {
        this.cache.remove(`${this.endpoint}/${item.id}`);
        this.cache.remove(`${this.endpoint}`);
        return resp.data || {}
      }))
  }


}
